import PaginationRequest from '@/common/pagination/entities/pagination-request'

export default class ActionGroupsRequest {
  public text = ''
  public paging: PaginationRequest = new PaginationRequest()
}
